import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { getErrorMessage } from '../../utils/errors-map';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-cannot-access-section',
    template: `
    <section>
      <h4 mat-dialog-title class="text-center">
        {{ 'CANNOT_ACCESS_SECTION' | translate }}
      </h4>
      <mat-dialog-content>
      @for (error of data.errors; track error) {
        <div>
          <p class="text-center">
            {{ getErrorMessage(error.code) }}
          </p>
        </div>
      }
      </mat-dialog-content>
      <mat-dialog-actions>
        <button mat-flat-button [routerLink]="[data.tenantId, 'planning']" mat-dialog-close>
          {{ 'GO_TO_PLANNING' | translate }}
        </button>

        <button mat-flat-button mat-dialog-close>
          {{ 'CLOSE' | translate }}
        </button>
      </mat-dialog-actions>
    </section>
    `,
    styles: [':host {max-width: 500px}'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, MatDialogClose, RouterLink, TranslateModule]
})
export class CannotAccessSectionComponent {
  data = inject<{
    tenantId: string;
    errors: {
        code: number;
    }[];
    onCloseUrl: string;
}>(MAT_DIALOG_DATA);

  getErrorMessage = getErrorMessage;
}
